<template>
  <Avatar
    :image="image"
    :label="label"
    :shape="shape"
    :size="size"
    :pt="{
      root: {
        class:[
          // Shape
          noBorder ? 'border-none' : 'border-2',

          // Color and Background
          borderColors,
          backgroundColorsArray[Number(backgroundColor)]
        ]
      },

      label: {
        class: [
          'mt-0.5'
        ]
      }
    }"
  >
    <slot />
  </Avatar>
</template>

<script setup>
import { ref, computed } from "vue";
import Avatar from 'primevue/avatar'

const props = defineProps({
  backgroundColor: {
    type: [String, Number],
    validator: (val) => [ '0', '1', '2', '3', '4', '5', 0, 1, 2, 3, 4, 5 ].includes(val),
    default: '5'
  },

  borderColor: {
    type: String,
    default: 'default'
  },

  noBorder: {
    type: Boolean
  },

  image: {
    type: String
  },

  label: {
    type: String
  },

  shape: {
    type: String,
    validator: (val) => ['circle', 'square'].includes(val),
    default: 'circle'
  },

  size: {
    type: String,
    validator: (val) => ['normal', 'large', 'xlarge'].includes(val),
    default: 'normal'
  }
})

const backgroundColorsArray = ref([
  'bg-iris-600 text-white',
  'bg-mantis-700 text-white',
  'bg-aqua-700 text-white',
  'bg-peach-600 dark:bg-peach-700 text-white',
  'bg-yellow-400 dark:bg-yellow-500 text-white',
  'bg-charcoal-500 dark:bg-charcoal-600 text-white',
])

const borderColors = computed(() => ({
  light: 'border-white dark:border-charcoal-900',
  dark: 'border-charcoal-50 dark:border-charcoal-950',
  default: 'border-semi-gray dark:border-charcoal-950'
}[props.borderColor]))
</script>